import React, { useEffect } from 'react';

import Fechamento from '../Fechamento';

const FechemantoDia: React.FC = () => {
  // useEffect(() => {
  //   document.title = 'Fechamento do Dia';
  // }, []);
  return <Fechamento tipo="fechamentodia" />;
};

export default FechemantoDia;
